import React from 'react';
import { Menu } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { AssignmentsMenu } from './AssignmentsMenu';
import { LessonPlannerMenu } from './LessonPlannerMenu';

type Props = {
  openMoveLessonModal: () => void;
  buttonClass: string;
  isAssignmentsView: boolean;
  handleEditAssignments: () => void;
  handleUnassign: () => void;
  handleViewAssignments: () => void;
  handleRemoveLesson: () => void;
  handleAssignLesson: () => void;
};

export const DayCardMenu: React.FC<Props> = React.forwardRef(
  (
    {
      openMoveLessonModal,
      buttonClass,
      isAssignmentsView,
      handleEditAssignments,
      handleUnassign,
      handleViewAssignments,
      handleRemoveLesson,
      handleAssignLesson
    },
    ref
  ) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClick = e => {
      setAnchorEl(e.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    return (
      <div>
        {
          <>
            <span
              role="button"
              onClick={handleClick}
              className={buttonClass}
              style={{ marginRight: 3 }}
            >
              <FontAwesomeIcon icon={faEllipsisH} size="sm" />
            </span>
            <Menu
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              {isAssignmentsView ? (
                <AssignmentsMenu
                  handleEditAssignments={handleEditAssignments}
                  handleUnassign={handleUnassign}
                  handleViewAssignments={handleViewAssignments}
                />
              ) : (
                <LessonPlannerMenu
                  ref={ref}
                  openMoveLessonModal={openMoveLessonModal}
                  handleRemoveLesson={handleRemoveLesson}
                  handleAssignLesson={handleAssignLesson}
                />
              )}
            </Menu>
          </>
        }
      </div>
    );
  }
);
